<template>
	<span v-if="business">{{ name }}</span>
</template>

<script>

import mixins from '@/mixins.js';

export default {
	mixins: [ mixins.businesses ],
	props: [ 'id' ],
	data: function() {
		return {
			data: false
		}
	},
	computed: {
		name: function() {

			return this.business.gyu_details.name;

		},
		business: function() {
			return this.data.business;
		}
	},
	created: function() {

		this.fetch();
		/*
		var object = this.asr.g(this.storageKey);
		if(object == undefined)
			this.fetch();
		else
			this.data = object;
		*/

	},
	methods: {
		fetch: function() {
			this.apiCompanyGet(this.id, [ 'Detail' ]).then(function(data) {
				this.data = data.data;
				// this.asr.s(this.storageKey, data.data);
			})
		}
	}
};

</script>